import React from 'react'
import dynamic from 'next/dynamic'
import styled from '@emotion/styled'

import { META } from '.config/meta'
import Layout from 'components/layouts/homepage/layout'
import AboutUs from 'components/layouts/homepage/aboutUs'
import { SectionWrapper, Title, InvestorsWrapper, InvestorsTextsWrapper, Text, Sub, ImageWrapper, CompaniesWrapper } from 'components/layouts/homepage/businessComponents'
const Image = dynamic(() => import('components/utils/image'), { ssr: false })

export default function AboutUsPage () {
  return (
    <Layout title={META.aboutUs.title} path={META.aboutUs.path} image={META.aboutUs.image} description={META.aboutUs.description} hero={<Hero />}>
      <Section/>
      <AboutUs title="Track Record" />
    </Layout>
  )
}

const HeroWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 100px;

  @media (max-width: 987px) {
    flex-direction: column;
    align-items: center;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
  align-items: center;
`

function Hero () {
  return (
    <SectionWrapper hero>
      <TitleWrapper>
        <Sub center>Our mission:</Sub>
        <Title data-test="reward" center hero>provide access to a curated list of pre-IPO tech companies</Title>
      </TitleWrapper>

      <HeroWrapper>
        <ImageWrapper hero>
          <Image
            className="w-100"
            src="team"
            type="png"
            alt="We are a team of seasoned investors with a proven track-record"
            width="540px"
            height="341px" />
        </ImageWrapper>
        <InvestorsTextsWrapper hero>
          <Text>
            Shareline is operated by Entier Capital, who was founded by a team of seasoned investors with a proven track-record in the technology space.
          </Text>
          <Text>
            We provide innovative capital solutions to existing stakeholders in high-growth category leaders with a proven technology and business model.
          </Text>
        </InvestorsTextsWrapper>
      </HeroWrapper>
    </SectionWrapper>
  )
}

const Wrapper = styled.div`
  padding-top: 110px;
`

function Section () {
  return (
    <Wrapper>
      <CompaniesWrapper>
        <InvestorsWrapper aboutUs>
          <Sub center>Our mission:</Sub>
          <Title data-test="reward" center>provide access to a curated list of pre-IPO tech companies</Title>
          <InvestorsTextsWrapper aboutUs>
            <Text>
              The investment presented to our investors are selected following a thorough due diligence process. We are driven by quality and not volume.
            </Text>
            <Text>
              Our revenue model allows an alignment of interest with our investors. Unlike brokers, we only earn a living when the investment is a success.
            </Text>
            <Text>
              Our automated platform allows to serve clients investing amounts as small as $25,000 with attractive investment terms.
            </Text>
          </InvestorsTextsWrapper>
        </InvestorsWrapper>
      </CompaniesWrapper>
    </Wrapper>
  )
}
